import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

// Box Elder/Union stays visible in the nav for everyone (legacy behavior),
// EXCEPT users scoped to the Plumb Ditch page. Admins/Developers keep it even
// if they also hold the Plumb Ditch role.
const BoxElderVisibilityFilter = ({ children }) => {
  const { user } = useAuth0();

  const roles = user?.[`${process.env.REACT_APP_AUDIENCE}/roles`] || [];
  const isAdmin = roles.some((x) => ["Administrator", "Developer"].includes(x));
  const isPlumbOnly = !isAdmin && roles.includes("Plumb Ditch");

  if (isPlumbOnly) return <React.Fragment />;

  return children;
};

export default BoxElderVisibilityFilter;
